import React from "react";
import { Label, Divider, Grid, Header } from "semantic-ui-react";
import { get, isEmpty } from "lodash";

import AppLink from "../Common/AppLink";
import DeleteModal from "../Common/DeleteModal";

export const CustomerGroupList = ({ customerGroups, tenantSlug }) => {
  return (
    <Grid padded>
      <Grid.Row verticalAlign="middle" columns={3}>
        <Grid.Column textAlign="left" width={2}>
          <h3>CUSTOMER GROUPS</h3>
        </Grid.Column>
        <Grid.Column>
          <Label size="large" circular color="black">
            {get(customerGroups, "length", 0)}
          </Label>
        </Grid.Column>
        <Grid.Column width={5} />
        <Grid.Column width={3} textAlign="right">
          <AppLink to="/customerGroups/new" icon="add" background content="New Customer Group" />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column width={12} as={Header} size="small" textAlign="left">
          Name (slug)
        </Grid.Column>
        <Grid.Column width={4} as={Header} size="small" textAlign="center">
          Actions
        </Grid.Column>
      </Grid.Row>
      <Divider />
      {!isEmpty(customerGroups) &&
        customerGroups.map((customerGroup, index) => {
          if (customerGroup.id !== tenantSlug)
            return <CustomerGroupRow row={index} customerGroup={customerGroup} key={index} />;
          else return null;
        })}

      {isEmpty(customerGroups) && (
        <Grid.Row textAlign="center">
          <Grid.Column>No customer groups</Grid.Column>
        </Grid.Row>
      )}
    </Grid>
  );
};

const CustomerGroupRow = ({ row, customerGroup }) => (
  <Grid.Row data-test={`customerGroups-tr-${row}`} columns={2}>
    <Grid.Column data-test="name" width={12}>
      {customerGroup.name} ({customerGroup.slug})
    </Grid.Column>
    <Grid.Column width={2} textAlign="right">
      <AppLink
        data-test="customerGroupEditButton"
        icon="edit"
        size="large"
        to={`/customerGroups/${customerGroup.id}/edit`}
        content="Edit"
      />
    </Grid.Column>

    <Grid.Column width={2} textAlign="left">
      <DeleteModal
        data-test="customerGroupDeleteButton"
        recordSlug={customerGroup.id}
        recordName={customerGroup.name}
        resourceName="customerGroups"
      />
    </Grid.Column>
  </Grid.Row>
);

export default CustomerGroupList;
